import React, { useState, useEffect, useRef } from 'react'
import Page from '../../layout/Page'
import { useSelector } from 'react-redux'
import { AppState } from '../../../redux'
import {
    Segment,
    Modal,
    Button,
    Icon,
    Form,
    Dropdown,
    Input,
    DropdownItemProps,
} from "semantic-ui-react";
import RoleRepository from '../../../common/repository/RoleRespository';
import LocalStorage from '../../../lib/LocalStorage';
import { useHistory } from "react-router-dom"
import Result from '../../../common/repository/Result';
import { toast } from 'react-toastify';
import constants from '../../../common/constants';

const IncentivePage = () => {
    const roleRepo = new RoleRepository()
    const authState = useSelector((state: AppState) => state.auth)
    const user = authState.user;
    const history = useHistory()

    const [selectedRole, setSelectedRole] = useState("")
    const [fileKey, setFileKey] = useState(Date.now());
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [performanceFile, setPerformanceFile] = useState<File | null>(null)
    const [uploading, setUploading] = useState(false)
    const [roleOptions, setRoleOptions] = useState<DropdownItemProps[]>([])
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadUserRole()
    }, [])

    const loadUserRole = async () => {
        try {
            setLoading(true);
            const results = await roleRepo.getRoles({
                level_greater_than: user?.getRole().getLevel(),
            })

            if (results instanceof Result.Success) {
                toast.success(results.message);
                const roles = results.data.items
                const formattedRoles = roles.filter((role) => role.getTitle() === constants.roleTitle.ca || role.getTitle() === constants.roleTitle.tl || role.getTitle() === constants.roleTitle.mis || role.getTitle() === constants.roleTitle.zo || role.getTitle() === constants.roleTitle.oh).map((role) => ({
                    key: role.getId(),
                    value: role.getId(),
                    text: role.getTitle(),
                }));
                setRoleOptions(formattedRoles);
            } else {
                toast.error(results.message);
            }
            
        } catch (error) {
            toast.error(error as string);
        } finally {
            setLoading(false);
        }
    }

    const uploadPerformanceSheet = async () => {
        try {

            setLoading(true);
            
            const formData = new FormData()
            formData.append("roleId", selectedRole)
            formData.append("performanceSheet", performanceFile!)

            const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN)

            const response = await fetch("/api/incentive/genrateIncentive", {
                method: "POST",
                headers: {
                    "x-access-token": token || "",
                },
                body: formData,
            })

            if (!response.ok) {
                toast.error(response.statusText);
            }

    
            const blob = await response.blob()

            const url = window.URL.createObjectURL(blob)
            const link = document.createElement("a")

            link.href = url
            link.download = "incentive_result.xlsx"

            document.body.appendChild(link)
            link.click()

            link.remove()
            window.URL.revokeObjectURL(url);
            setPerformanceFile(null)
            setSelectedRole("");

        } catch (error) {
           toast.error(error as string);
        } finally {
            setLoading(false)
        }
    }

    return (
        <Page
            title="Incentive Upload"
            description="Upload performance sheet for incentive calculation"
            action={
                <Button
                    primary 
                    onClick={() => {
                        setSelectedRole("");
                        setPerformanceFile(null);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setUploading(false);
                        setFileKey(Date.now());
                    }}
                >
                    
                    Clear
                </Button>
            }
        >
          
        <Segment.Group style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
            <Segment
                style={{
                width: "100%",
                maxWidth: "700px",
                padding: "20px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "flex-start",
                gap: "15px"
                }}
            >
                
                <Form style={{ flex: 1, margin: 0 }}>
                <Form.Field style={{ marginBottom: 0 }}>
                    <label style={{ marginBottom: "6px", display: "block" }}>Role</label>

                    <Dropdown
                    disabled = {uploading} 
                    fluid
                    selection
                    placeholder="Select Role"
                    options={roleOptions}
                    value={selectedRole}
                    onChange={(e, { value }) => setSelectedRole(value as string)}
                    />
                </Form.Field>
                </Form>

                <Form style={{ flex: 1, margin: 0 }}>
                <Form.Field style={{ marginBottom: 0 }}>
                    <label style={{ marginBottom: "6px", display: "block" }}>
                    Upload Excel File
                    </label>

                    <Input
                    type="file"
                    key={fileKey}
                    accept=".xlsx,.xls"
                    style={{ width: "100%" }}
                    onChange={(e) => {
                        const file = (e.target as HTMLInputElement).files?.[0]
                        if (file) setPerformanceFile(file);
                        setUploading(true);
                    }}
                    />
                </Form.Field>

                <Button
                    primary
                    disabled = {performanceFile === null}
                    loading={loading}
                    onClick={uploadPerformanceSheet}
                    style={{ marginTop: "10px" }}
                >
                    Upload
                </Button>
                </Form>

            </Segment>
        </Segment.Group>

    </Page>
    )
}

export default IncentivePage